/**
 * Created by Jerker Nord on 2021-01-28.
 */
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Loner} from "../Loner";
import {SimplePresentation, SimplePresentationRunner} from "../../core/winpresentation/SimplePresentationRunner";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {LonerGameMode} from "../server/LonerGameMode";
import {LonerStatics} from "../LonerStatics";
import {
    LonerPinTheWinResultPresentation
} from "../presentationrunners/features/pinthewin/LonerPinTheWinResultPresentation";

export class LonerIdleNormalTrigger implements FlowStatePresentation {

    private _presentations: SimplePresentation[];
    private _controller: FlowStateController
    private _startIndividualWin: boolean = false;
    private _initialWinDone: boolean = false;
    private _bigWinDone: boolean = false;
    private _isComplete: boolean = false;

    constructor() {
        this._presentations = []
    }

    public start(flowStateController: FlowStateController): void {
        if (Loner.model.featureTrigger === LonerStatics.MAX_WIN_TEASE_TRIGGER) {
            Loner.soundPlayer.fadeMusic(0, 1, 0.001);
        }
        if(Loner.isGodModeRound){
            Loner.isGodModeRound=false;
        }
        if(Loner.model.mode===LonerGameMode.FEATURE_PIN_THE_WIN){
            LonerPinTheWinResultPresentation.setSubTlAddedToMainTlFlag(false);
        }
        this._controller = flowStateController;
        if (!Loner.isWinBelowPlayedBetValue() && !Loner.autoPlayPlugin.isAutoplayRound) {
            this._startIndividualWin = true;
            this.checkReadyForIndividualWin();
        }
        Loner.xBetView.unPauseRedDotBlinkTL();

        SimplePresentationRunner.run(this._presentations, () => this.presentationComplete(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }

    private presentationComplete(): void {
        this._isComplete = true;
        this.checkComplete();
    }

    private checkComplete(): void {
        if (this._isComplete == true) {
            if (Loner.model.data.mode == LonerGameMode.NORMAL && Loner.model.accumulatedRoundWin && Loner.model.accumulatedRoundWin > 0) {
                if (this._initialWinDone == true) {
                    this._isComplete = false;
                    this.doFinish();
                }
            } else {
                this._isComplete = false;
                this.doFinish();
            }
        }
    }

    private doFinish(): void {
        this._initialWinDone = false;
        this._bigWinDone = false;
        this._startIndividualWin = false;
        this._controller.finish();
    }

    private checkReadyForIndividualWin(): void {
        if (this._startIndividualWin == true && this._initialWinDone == true && this._bigWinDone == true) {
            this._startIndividualWin = false;
            this._bigWinDone = false;
            Loner.individualWin.start();
        }
    }

    set initialWinDone(value: boolean) {
        this._initialWinDone = value;
        this.checkReadyForIndividualWin();
    }

    set bigWinDone(value: boolean) {
        this._bigWinDone = value;
        this.checkReadyForIndividualWin();
    }
}